/**
 *  디폴트 레이아웃 아이디
 * @since 0.0.1
 * @author Heungsoo Ham, Jongkwang Park
 * @enum
 */
export enum DefaultLayoutId {
    FLOWX = "_XkH2suMpDx37zCTywsa9TPDhT_JOeKs",
    FLOWXL = "_M8iNUZo0oA014fu8bQelSDo5DNN7XJJ",
    FLOWY = "_TNtwnrru7yu0krTGLUEK1ImgUgqXUdl",
    ONLYCOMPONENTELEMENT = "_B30ouiXDulMJ3FtOZfxcDkqTetzToOK",
    WITHOUTLABEL = "_HTlFZLdJVmG5DneJWkpAQoAgZJchSw7"
}
